import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import Homie from "@/pages/Homie";

export const Route = createFileRoute("/homie/")({
  head: () => seoHead("/homie"),
  component: Homie,
});
